import { defineAbility } from '@casl/ability'

export default defineAbility((can, cannot) => {
	cannot('create', 'all')
	cannot('read', 'all')
	cannot('update', 'all')
	cannot('delete', 'all')
})
